import React, { useState, useEffect } from 'react';
import cogoToast from 'cogo-toast';
import { confirmAlert } from 'react-confirm-alert';
import './BrandBillingStripeIdField.scss';

/*
  Stripe ids are editable in place because a brand pointed at the wrong one is what fires the daily
  "could not retrieve a Stripe customer" alert. Saving confirms against what Stripe says the id is,
  never against what was typed — the wrong id silently misroutes a brand's money.
*/
const BrandBillingStripeIdField = props => {
  const { label, value, placeholder, linkUrl } = props;
  const [draft, setDraft] = useState(value || '');
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => setDraft(value || ''), [value]);
  const isDirty = draft.trim() !== (value || '');

  const save = async () => {
    const nextId = draft.trim();
    if (!nextId) return;

    setIsSaving(true);
    let preview;
    try {
      preview = await props.onPreview(nextId);
    } catch (e) {
      setIsSaving(false);
      return cogoToast.error(e?.response?.data?.error || 'Stripe could not find that id.');
    }
    setIsSaving(false);

    return confirmAlert({
      title: `Point this brand at ${nextId}?`,
      message: props.describePreview(preview),
      buttons: [
        { label: 'Cancel', onClick: () => {}, className: 'cancel' },
        {
          label: 'Save',
          onClick: async () => {
            try {
              await props.onSave(nextId);
              cogoToast.success('Saved.');
            } catch (e) {
              cogoToast.error(e?.response?.data?.error || 'Could not save that id.');
            }
          }
        }
      ]
    });
  };

  return (
    <div className='brand-billing-idfield'>
      <div className='brand-billing-idfield-label'>{label}</div>
      <div className='brand-billing-idfield-row'>
        <input
          className='brand-billing-input'
          aria-label={label}
          value={draft}
          placeholder={placeholder}
          spellCheck={false}
          onChange={e => setDraft(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && isDirty && save()}
        />
        {isDirty ? (
          <button className='brand-billing-save' disabled={isSaving} onClick={save}>
            {isSaving ? 'Checking…' : 'Save'}
          </button>
        ) : (
          !!value && (
            <a className='brand-billing-open' href={linkUrl} target='_blank' rel='noopener noreferrer'>
              Open
            </a>
          )
        )}
      </div>
    </div>
  );
};

export default BrandBillingStripeIdField;
